<template>

    <div class="dash-content-outer col">

        <div class="head w-intro">
            <div class="col">
                <h5 class="txt-grt">Homepage</h5>
                <p>This page represents your homepage, you can add, delete or organize rows as you wish</p>
            </div>
            <div class="actns">
                <div class="btn main txt-blk" @click.prevent="openRowOverlay">
                    <span class="hvr"></span>
                    <span class="ico">
                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM11.5 11.5V6.5H14.5V11.5H19.5V14.5H14.5V19.5H11.5V14.5H6.5V11.5H11.5Z" fill="black"/>
                        </svg>
                    </span>
                    <span class="txt">Add new row</span>
                </div>
            </div>
        </div>

        <transition-group name="list" tag="div" class="inner-content hp">

            <ContentRow v-for="row,rIndex in rows" :key="row.id"
                :row="row"
                :index="rIndex"
            >
                <ContentCard v-for="asset,cIndex in row.assets" :key="asset.name+cIndex"
                    :title="asset.name"
                    :posterSrc="asset.poster"
                    :moneyTag="Global.plans[0].name"
                    :genreTags="asset.tags"
                    :index="cIndex"
                >
                </ContentCard>
               
            </ContentRow>

        </transition-group>

    </div>

</template>

<style scoped>
    .list-move {
        transition: transform 400ms ease-out;
    }    
</style>

<script>

    import Global from '../../lib/GlobalState'
    import ContentCard from '../../components/ContentCard'
    import ContentRow from '../../components/ContentRow'

    export default {

        name: 'Homepage',

        components: {
            ContentCard,
            ContentRow
        },

        data() {
            return {
                Global
            }
        },

        mounted() {
            setTimeout(() => { this.toggleHelper() }, 1500)
        },

        computed: {

            rows() {

                const rows = Object.assign([], this.Global.rows)
                return rows.map((row,index) => {
                    const lRow = Object.assign({}, row)
                    lRow.index = index
                    lRow.assets = lRow.assets.map((assetIndex) => {
                        return this.Global.assets[assetIndex]
                    }).filter((asset) => asset)
                    return lRow
                })
            }
        },

        methods: {

            openRowOverlay() {
                this.Global.rowIdToEdit = null
                this.Global.newRowOverlay = {
                    type: "auto",
                    name: null,
                    content: null,
                    tags: [],
                    sort: null,
                    assetsCount: 10,
                    assets: []
                }

                this.$parent.openRowOverlay()
            },

            toggleHelper() {
                if(this.$route.path !== '/dashboard/homepage' || this.Global.RowsHelperOverlayState > 0) return
                this.Global.tempHelperClosingOverlay = false
                this.Global.activeHelperOverlay = true
                this.Global.RowsHelperOverlayState = 1
            },
            
        }
    }

</script>